module.exports = __webpack_public_path__ + "static/img/Tohu-Harris.25df620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tohu-Harris.jpg
// module id = BWV4
// module chunks = 0